var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6.66667C20 2.98444 17.0156 0 13.3333 0C11.21 0 8.79 0 6.66667 0C2.98444 0 0 2.98444 0 6.66667C0 8.79 0 11.21 0 13.3333C0 17.0156 2.98444 20 6.66667 20C8.79 20 11.21 20 13.3333 20C17.0156 20 20 17.0156 20 13.3333V6.66667ZM17.7778 6.66667V13.3333C17.7778 15.7878 15.7878 17.7778 13.3333 17.7778H6.66667C4.21222 17.7778 2.22222 15.7878 2.22222 13.3333V6.66667C2.22222 4.21222 4.21222 2.22222 6.66667 2.22222H13.3333C15.7878 2.22222 17.7778 4.21222 17.7778 6.66667ZM8.88889 5.55556V9.54L5.88111 12.5478C5.44778 12.9811 5.44778 13.6856 5.88111 14.1189C6.31444 14.5522 7.01889 14.5522 7.45222 14.1189L10.7856 10.7856C10.9944 10.5778 11.1111 10.2944 11.1111 10V5.55556C11.1111 4.94222 10.6133 4.44444 10 4.44444C9.38667 4.44444 8.88889 4.94222 8.88889 5.55556Z",
    fill: "#838486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSelector);
export default __webpack_public_path__ + "static/media/TimeSelector.0743d1514a2032f064960a4588772f00.svg";
export { ForwardRef as ReactComponent };